var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import ReactMarkdown from 'react-markdown';
import moment from "moment";

import { LayoutField, FieldText, ModuleBody, ModuleLink, ModuleFooter, ButtongroupInline, ButtonSecondary, ButtonTertiary, NavAction, NavSettings } from '../';

import InboxMessage from "./InboxMessage";
import InboxMessageHeaders from "./InboxMessageHeaders";
import InboxMessageBody from "./InboxMessageBody";
import InboxMessageReply from "./InboxMessageReply";

var LayoutInboxChild = (_temp2 = _class = function (_Component) {
    _inherits(LayoutInboxChild, _Component);

    function LayoutInboxChild() {
        var _temp, _this, _ret;

        _classCallCheck(this, LayoutInboxChild);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            editing: false,
            expanded: false,
            prevFormData: {},
            reply: {
                expanded: false,
                formData: {}
            }
        }, _this.onToggle = function () {
            _this.setState({
                expanded: !_this.state.expanded
            });
        }, _this.onEdit = function () {
            var _this$props = _this.props,
                id = _this$props.id,
                index = _this$props.index,
                schema = _this$props.schema,
                formData = _this$props.formData,
                formContext = _this$props.formContext;


            _this.setState({
                prevFormData: formData,
                editing: true
            });

            if (formContext.onEditMessage) {
                formContext.onEditMessage({
                    index: index,
                    formData: formData
                });
            }
        }, _this.onDiscard = function () {
            var _this$props2 = _this.props,
                id = _this$props2.id,
                index = _this$props2.index,
                schema = _this$props2.schema,
                formData = _this$props2.formData,
                formContext = _this$props2.formContext;


            if (formContext.onDiscardDraft) {
                formContext.onDiscardDraft({
                    index: index,
                    formData: formData
                });
            }

            if (_this.props.onChange) {
                _this.props.onChange(_this.state.prevFormData);
            }

            _this.setState({
                editing: false
            });
        }, _this.onReply = function () {
            var _this$props3 = _this.props,
                id = _this$props3.id,
                index = _this$props3.index,
                schema = _this$props3.schema,
                formData = _this$props3.formData,
                formContext = _this$props3.formContext;
            var author = formContext.author;


            var parentId = formData.uniqueId;
            var replyTo = formData.author.name + " <" + formData.author.email + ">";
            var replyFrom = author.name + " <" + author.email + ">";
            var subject = "Re: " + formData.subject;

            var reply = {
                expanded: true,
                formData: {
                    parentId: parentId,
                    //            status: "draft",
                    author: author,
                    subject: subject,
                    from: replyFrom,
                    to: replyTo,
                    message: ""
                }
            };

            _this.setState({
                reply: reply
            });
        }, _this.onChangeReply = function (formData) {

            _this.setState({
                reply: _extends({}, _this.state.reply, {
                    formData: formData
                })
            });
        }, _this.onDiscardReply = function () {
            var _this$props4 = _this.props,
                index = _this$props4.index,
                formContext = _this$props4.formContext;
            var reply = _this.state.reply;


            if (formContext.onDiscardReply) {
                formContext.onDiscardReply({
                    index: index,
                    formData: reply.formData
                });
            }

            _this.setState({
                reply: {
                    expanded: false,
                    message: ""
                }
            });
        }, _this.onSaveReply = function (status) {
            var _this$props5 = _this.props,
                id = _this$props5.id,
                index = _this$props5.index,
                schema = _this$props5.schema,
                formContext = _this$props5.formContext;
            var reply = _this.state.reply;


            if (!status) {
                status = "draft";
            }

            var newFormData = _extends({}, reply.formData, {
                createdAt: moment().format(),
                status: status

                //        setTimeout(() => { 

            });if (_this.props.onAddAfter) {
                _this.props.onAddAfter(newFormData);
            }

            if (formContext.onSaveReply) {
                formContext.onSaveReply({
                    index: index,
                    formData: newFormData
                });
            }

            _this.setState({
                reply: {
                    expanded: false,
                    formData: {}
                }
            });

            //        })

        }, _this.onSave = function (status) {
            var _this$props6 = _this.props,
                id = _this$props6.id,
                index = _this$props6.index,
                schema = _this$props6.schema,
                formData = _this$props6.formData,
                formContext = _this$props6.formContext;


            if (!formData.status) {
                status = "draft";
            }

            var newFormData = _extends({}, formData, {
                createdAt: formData.createdAt || moment().format(),
                updatedAt: moment().format(),
                status: status

                //        setTimeout(() => { 

            });if (_this.props.onChange) {
                _this.props.onChange(newFormData);
            }

            if (formContext.onSaveMessage) {
                formContext.onSaveMessage({
                    index: index,
                    formData: newFormData
                });
            }

            _this.setState({
                expanded: false,
                editing: false
            });

            //        })

        }, _this.onDelete = function () {
            var _this$props7 = _this.props,
                id = _this$props7.id,
                index = _this$props7.index,
                schema = _this$props7.schema,
                formData = _this$props7.formData,
                formContext = _this$props7.formContext;

            //        setTimeout(() => { 

            if (formContext.onDeleteMessage) {
                formContext.onDeleteMessage({
                    index: index,
                    formData: formData
                });
            }

            if (_this.props.onDelete) {
                _this.props.onDelete();
            }

            _this.setState({
                expanded: false,
                editing: false
            });

            //        })
        }, _this.getLabel = function () {
            var _this$props$formData = _this.props.formData,
                uniqueId = _this$props$formData.uniqueId,
                status = _this$props$formData.status,
                date = _this$props$formData.date,
                from = _this$props$formData.from,
                to = _this$props$formData.to,
                name = _this$props$formData.name,
                email = _this$props$formData.email,
                message = _this$props$formData.message;


            var label = void 0;

            if (status === "new") {
                label = "New";
            }

            if (status === "open") {
                label = "Open";
            }

            return label;
        }, _this.getPreview = function () {
            var formData = _this.props.formData;


            var label = _this.getLabel();

            var isFirstMessage = _this.isFirstMessage();
            var isLastMessage = _this.isLastMessage();

            var isExpanded = _this.isExpanded();
            var isEditing = _this.isEditing();

            return _extends({}, formData, {
                label: label,
                editing: isEditing,
                expanded: isExpanded || isLastMessage
            });
        }, _this.getSettings = function () {
            var _this$props8 = _this.props,
                editable = _this$props8.editable,
                formData = _this$props8.formData,
                index = _this$props8.index,
                onEdit = _this$props8.onEdit;
            var uniqueId = formData.uniqueId;
            var reply = _this.state.reply;


            if (reply.expanded) {
                return false;
            }

            var settings = [];

            //        if (uniqueId) {
            settings.push({
                icon: "reply",
                onClick: function onClick() {
                    return _this.onReply();
                }
            });
            //        }

            if (editable) {
                settings.push({
                    icon: "edit",
                    onClick: function onClick() {
                        return _this.onEdit();
                    }
                });
            }

            return settings;
        }, _this.renderButton = function (button, index) {

            return React.createElement(ButtonSecondary, _extends({}, button, { key: index }));
        }, _this.renderFooter = function () {
            var _this$props9 = _this.props,
                expanded = _this$props9.expanded,
                editable = _this$props9.editable,
                removable = _this$props9.removable,
                onEdit = _this$props9.onEdit;


            var editing = _this.isEditing();

            var saveButton = {
                title: "Save",
                onClick: function onClick() {
                    return _this.onSave();
                },
                children: [{
                    title: "Save as open",
                    onClick: function onClick() {
                        return _this.onSave('open');
                    }
                }, {
                    title: "Save and close",
                    onClick: function onClick() {
                        return _this.onSave('close');
                    }
                }]
            };

            var deleteButton = {
                title: "Delete",
                onClick: _this.onDelete
            };

            var cancelButton = {
                title: "Cancel",
                onClick: _this.onDiscard
            };

            if (editing) {

                return React.createElement(
                    ModuleFooter,
                    null,
                    React.createElement(
                        ButtongroupInline,
                        null,
                        React.createElement(NavAction, { button: saveButton, align: 'left', buttonType: 'secondary' }),
                        React.createElement(ButtonSecondary, deleteButton),
                        React.createElement(ButtonSecondary, cancelButton)
                    )
                );
            }
        }, _this.isEditing = function () {
            return _this.state.editing;
        }, _this.isExpanded = function () {
            return _this.state.expanded;
        }, _this.isFirstMessage = function () {
            var _this$props10 = _this.props,
                index = _this$props10.index,
                formContext = _this$props10.formContext;


            if (index === 0) {
                return true;
            }

            return false;
        }, _this.isLastMessage = function () {
            var _this$props11 = _this.props,
                index = _this$props11.index,
                formContext = _this$props11.formContext;
            var messagesCount = formContext.messagesCount;


            if (index + 1 === messagesCount) {
                return true;
            }

            return false;
        }, _this.renderReply = function () {
            var _this$props12 = _this.props,
                index = _this$props12.index,
                formContext = _this$props12.formContext;
            var messagesCount = formContext.messagesCount;
            var reply = _this.state.reply;


            if (reply.expanded) {
                return React.createElement(InboxMessageReply, _extends({}, reply, { onChange: _this.onChangeReply, onSave: _this.onSaveReply, onDiscard: _this.onDiscardReply }));
            }

            if (index + 1 === messagesCount) {
                return React.createElement(
                    ModuleFooter,
                    null,
                    React.createElement(
                        ButtongroupInline,
                        null,
                        React.createElement(ButtonSecondary, { title: 'Reply', onClick: _this.onReply })
                    )
                );
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    LayoutInboxChild.prototype.render = function render() {
        var preview = this.getPreview();
        var status = preview.status,
            date = preview.date,
            label = preview.label,
            author = preview.author,
            email = preview.email,
            message = preview.message,
            expanded = preview.expanded,
            editing = preview.editing;


        var settings = this.getSettings();

        if (editing) {

            return React.createElement(
                InboxMessage,
                _extends({}, preview, { expanded: true }),
                React.createElement(InboxMessageHeaders, preview),
                React.createElement(
                    InboxMessageBody,
                    null,
                    this.props.children
                ),
                this.renderFooter()
            );
        }

        if (expanded) {

            return React.createElement(
                InboxMessage,
                preview,
                React.createElement(InboxMessageHeaders, _extends({}, preview, { onClick: this.onToggle })),
                React.createElement(InboxMessageBody, preview),
                this.renderReply(),
                React.createElement(NavSettings, { settings: settings })
            );
        }

        return React.createElement(
            InboxMessage,
            preview,
            React.createElement(InboxMessageHeaders, _extends({}, preview, { onClick: this.onToggle })),
            React.createElement(InboxMessageBody, _extends({}, preview, { onClick: this.onToggle }))
        );
    };

    return LayoutInboxChild;
}(Component), _class.defaultProps = {
    buttons: [],
    settings: []
}, _temp2);


export default LayoutInboxChild;